// NOTE: 무신사 표준 응답 형식이 http 모듈에 포함시켜도되는지 논의 필요.

/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AxiosError } from 'axios';
import type { ZodArray, ZodRawShape } from 'zod';
import { z } from 'zod';

export interface ErrorDataModel {
  errorCode?: string;
  httpStatus?: string;
  message?: string;
  timestamp?: string;
  traceId?: string;
  meta?: StandardResponseMeta;
}

export interface StandardResponseErrorModel<T = ErrorDataModel> {
  data: T | undefined;
  message: string;
  status: number | undefined;
}

const linkSchema = z.object({
  next: z.string().nullable().optional(),
  prev: z.string().nullable().optional(),
  total: z.number().nullable().optional(),
});

export type StandardResponseLink = z.infer<typeof linkSchema>;

export const metaSchema = z.object({
  result: z.enum(['SUCCESS', 'FAIL']),
  errorCode: z.string().nullish(),
  message: z.string().nullable(),
  totalCount: z.number().nullable(),
});

export type StandardResponseMeta = z.infer<typeof metaSchema>;

// TODO: 함수 오버로딩으로 해결 가능한지 확인
export type StandardResponseSchema<T> = T extends ZodRawShape
  ? z.ZodObject<T>
  : T extends ZodArray<z.ZodObject<any>, 'many'>
    ? T
    : never;
export const standardResponseSchema = <T>(schema: StandardResponseSchema<T>) =>
  z.object({
    meta: metaSchema.optional(),
    data: schema,
    link: linkSchema.optional(),
  });

/**
 * @link https://wiki.musinsa.com/pages/viewpage.action?pageId=190626753
 * @description 무신사 API 응답 표준
 */
export type StandardResponse<T> = z.infer<ReturnType<typeof standardResponseSchema<T>>>;
export interface MusinsaStandardResponse<T> {
  meta?: StandardResponseMeta;
  data: T;
  link?: StandardResponseLink | null;
}

export const standardResponseErrorToData = <T>({
  response,
  message = '서버와의 통신에 실패했습니다.',
}: AxiosError<T>): StandardResponseErrorModel<T> => ({
  data: response?.data,
  message: (response?.data as StandardResponseErrorModel | undefined)?.message || message,
  status: response?.status,
});
